import type {DynamicLabelExtra} from 'src/action-creators/dynamic-labels';
import type {EntityType} from 'src/types/ats-entities';
import type {Props as TokenListInputProps} from 'src/components/lib/token-list-input/token-list-input.old';

import * as React from 'react';
import {useDispatch} from 'react-redux';
import noop from 'lodash/noop';

import {dedupBridgedDynamicLabels} from 'src/utils/dynamic-labels';
import classify from 'src/utils/classify';

import {pushModal} from 'src/action-creators/modal';

import {MultiEntityLabel} from 'src/components/lib/markdown-editor/dynamic-text';

import css from './variable-picker.css';


function MultiEntityVariableSelect({
  containerClassName,
  onChange,
  options,
  errors,
  value,
  entityType,
  allowUnsyncedFields,
  placeholder,
}: {
  options: DynamicLabelExtra[];
  entityType: EntityType | null | undefined;
  value?: string | null | undefined;
  allowUnsyncedFields?: boolean;
  errors?: string[];
  onChange: (arg1: DynamicLabelExtra) => void;
  containerClassName?: string;
  placeholder?: string;
  ['data-qa-id']?: string;
}) {
  const dedupedOptions = React.useMemo(
    // @ts-expect-error - TS2769 - No overload matches this call.
    () => Array.from(dedupBridgedDynamicLabels(options)),
    [options],
  );

  const dispatch = useDispatch();
  const handleOnFocus = () => {
    dispatch(
      pushModal({
        type: 'VARIABLE_PICKER',
        // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'labels' does not exist in type 'BasicModal'.
        labels: dedupedOptions,
        // @ts-expect-error - TS7006 - Parameter 'dynamicLabel' implicitly has an 'any' type.
        insertResult: (dynamicLabel) => {
          onChange(dynamicLabel);
        },
        entityType,
        allowUnsyncedFields,
      }),
    );
  };
  const selectedFieldMeta = React.useMemo(
    () =>
      // @ts-expect-error - TS18046 - 'field' is of type 'unknown'.
      value ? dedupedOptions.find((field) => value === field.value) : undefined,
    [value],
  );

  return (
    <div
      className={classify(css.modalInputContainer, containerClassName, {
        [css.errorInput]: errors,
      })}
      onClick={handleOnFocus}
    >
      {value ? (
        // @ts-expect-error - TS2739 - Type '{ children: any; onClick: (...args: any[]) => void; option: unknown; }' is missing the following properties from type 'MultiEntityLabelComponentProps': type, baseEntityType, useNewDesignSystem
        <MultiEntityLabel onClick={noop} option={selectedFieldMeta}>
          {/* @ts-expect-error - TS2339 - Property 'label' does not exist on type '{}'. */}
          {selectedFieldMeta?.label}
        </MultiEntityLabel>
      ) : (
        <span className={css.placeholder}>
          {placeholder ?? 'select variable'}
        </span>
      )}
    </div>
  );
}

export default MultiEntityVariableSelect;
